import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltungs-typ-detail';
import * as api from '../../../clients/veranstaltungstypen';

@Injectable()
export class VeranstaltungstypenVeranstaltungsTypDetailEffects {

    VeranstaltungsTypDetail$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNGS_TYP_DETAIL),
        mergeMap((x: ac.GetVeranstaltungsTypDetailAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungsTypDetail(x.veranstaltungstyp_id).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungsTypDetailErfolgreichAction(result, x.veranstaltungstyp_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungsTypDetailFehlerAction(error, x.veranstaltungstyp_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VeranstaltungsTypenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VeranstaltungsTypenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.VeranstaltungsTypenQueryService);
        }
        return this.service;
    }
}
